import React, { useEffect, useState } from "react";
import { GetGVPCountDashboard } from "../../Apis/DashboardApis/GvpDashbaordApi";
import { toast } from "react-toastify";
import Loader from "../../Common/Loader/loader";
import DashboardCardLoader from "../../Common/DashboardCardLoader/DashboardCardLoader";
import Select from "react-select";
import { getMasterAPIStore } from "../../../utils/getMasterAPIStore";
import { CorporationStore } from "../corporation_master/CorporationStore";
import { Field, Form, Formik } from "formik";
import KMLmap from "./googlemap/KMLmap";
import { DashBoardStore } from "./DashBoardStore";
import CountUp from "react-countup";

/* ---------------- HELPERS ---------------- */

const getStartOfCurrentDateTime = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  const hours = String(now.getHours()).padStart(2, "0");
  const minutes = String(now.getMinutes()).padStart(2, "0");
  return `${year}-${month}-${day}T${hours}:${minutes}`;
};

const getEndOfCurrentDay = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}T23:59`;
};

/* ---------------- COMPONENT ---------------- */

const GvpDashboardReport = () => {
  const { shiftLoading, shiftData } = getMasterAPIStore();
  const { fetchUserCorporations, UserCorporations } = CorporationStore();
  const {
    fetchGvpDashboardDetails,
    GvpDashboardDetails,
    isGvpDashboardLoading,
  } = DashBoardStore();

  const [hoveredCard, setHoveredCard] = useState(null);

  const initialValues = {
    startDate: getStartOfCurrentDateTime(),
    endDate: getEndOfCurrentDay(),
    shiftId: "",
    corporationIds: [],
  };

  const onSubmit = (values) => {
    console.log("Form values on submit:", values);
    fetchGvpDashboardDetails(values);
  };

  useEffect(() => {
    const startDateTime = getStartOfCurrentDateTime();
    const endDateTime = getEndOfCurrentDay();
    fetchUserCorporations();
  }, []);

  /* ---------------- OPTIONS ---------------- */

  const corporationOptions = (UserCorporations || []).map((corp) => ({
    value: corp.corporationId,
    label: corp.corporationName,
  }));

  const GvpCards = [
    {
      title: "Gvp Master",
      value:
        GvpDashboardDetails?.length > 0 ? GvpDashboardDetails[0].TotalGvps : 0,
      accent: "#4A90D9",
    },
    {
      title: "GVPs Cleared",
      value:
        GvpDashboardDetails?.length > 0
          ? GvpDashboardDetails[0].UniqueGVPCleared
          : 0,
      accent: "#27AE60",
    },
    {
      title: "Percentage %",
      value:
        GvpDashboardDetails?.length > 0 ? GvpDashboardDetails[0].Percentage : 0,
      accent: "#E67E22",
    },
  ];

  /* ---------------- AUTO LOAD DASHBOARD ---------------- */

  useEffect(() => {
    onSubmit(initialValues);
  }, []);

  return (
    <div style={{ width: "100%" }}>
      <div className="content">
        <div className="page-content">
          <h4 className="text-start mb-3"> GVPs Dashboard</h4>
          <div className="card">
            <div className="card-body">
              <div className="row " style={{ textAlign: "justify" }}>
                <div className="col-md-12">
                  <Formik
                    initialValues={initialValues}
                    enableReinitialize
                    onSubmit={onSubmit}
                  >
                    {({ values, setFieldValue }) => (
                      <Form>
                        <div className="row" style={{ textAlign: "justify" }}>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label htmlFor="startDate">From Date & Time</label>
                              <Field
                                type="datetime-local"
                                className="form-control"
                                id="startDate"
                                name="startDate"
                                style={{
                                  backgroundColor: "#FFF",
                                  borderRadius: "0px",
                                }}
                                value={values.startDate}
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label htmlFor="endDate">To Date & Time</label>
                              <Field
                                type="datetime-local"
                                className="form-control"
                                id="endDate"
                                name="endDate"
                                style={{
                                  backgroundColor: "#FFF",
                                  borderRadius: "0px",
                                }}
                                value={values.endDate}
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label htmlFor="CorporationIds">
                                Select Corporation
                              </label>
                              
                              <Select
                                inputId="corporationIds"
                                isMulti
                                options={corporationOptions}
                                value={corporationOptions.filter((opt) =>
                                  values.corporationIds.includes(opt.value),
                                )}
                                onChange={(selected) =>
                                  setFieldValue(
                                    "corporationIds",
                                    (selected || []).map((c) => c.value),
                                  )
                                }
                                placeholder="Select Corporation(s)"
                                styles={{
                                  control: (base) => ({
                                    ...base,
                                    borderRadius: "0px",
                                    backgroundColor: "#ececec",
                                  }),
                                  placeholder: (base) => ({
                                    ...base,
                                    marginLeft: "6px",
                                  }),
                                  indicatorSeparator: (base) => ({
                                    ...base,
                                    backgroundColor: "#fff",
                                  }),
                                }}
                              />
                            </div>
                          </div>

                          <div className="col-md-4 ">
                            <div className="form-group">
                              <label className="form-label">Select Shift</label>
                              <Field
                                as="select"
                                name="shiftId"
                                className="form-select"
                                value={values.shiftId}
                                style={{
                                  backgroundColor: "#FFF",
                                  borderRadius: "0px",
                                }}
                              >
                                {shiftLoading && (
                                  <option value="">Loading...</option>
                                )}
                                <option value="">All</option>

                                {Array.isArray(shiftData) &&
                                  shiftData.map((shift) => (
                                    <option
                                      key={shift.shiftId}
                                      value={shift.shiftId}
                                    >
                                      {shift.shiftName}
                                    </option>
                                  ))}
                              </Field>
                            </div>
                          </div>
                          <div className="col-md-4 mt-4">
                            <button type="submit" className="btn search-swm">
                              Submit
                            </button>
                          </div>
                        </div>
                      </Form>
                    )}
                  </Formik>
                </div>
              </div>
            </div>
          </div>

          {isGvpDashboardLoading ? <DashboardCardLoader count={3} /> : null}

          <div className="row mt-3 g-3">
            {!isGvpDashboardLoading &&
              GvpCards.map((card, index) => {
                const isHovered = hoveredCard === index;
                return (
                  <div className="col-md-4" key={index}>
                    <div
                      className="card border-0"
                      onMouseEnter={() => setHoveredCard(index)}
                      onMouseLeave={() => setHoveredCard(null)}
                      style={{
                        borderRadius: "12px",
                        background: "#f8f9fa",
                        boxShadow: isHovered
                          ? "0 12px 28px rgba(0,0,0,0.15)"
                          : "0 2px 8px rgba(0,0,0,0.08)",
                        transform: isHovered
                          ? "translateY(-6px) scale(1.02)"
                          : "translateY(0) scale(1)",
                        transition: "all 0.25s ease",
                        cursor: "pointer",
                      }}
                    >
                      <div
                        className="card-body"
                        style={{ padding: "20px 24px" }}
                      >
                        <div
                          style={{
                            width: "40px",
                            height: "4px",
                            backgroundColor: card.accent,
                            borderRadius: "2px",
                            marginBottom: "14px",
                          }}
                        />
                        <p
                          className="mb-1"
                          style={{
                            fontSize: "13px",
                            color: "#6c757d",
                            fontWeight: 500,
                            textTransform: "uppercase",
                            letterSpacing: "0.5px",
                          }}
                        >
                          {card.title}
                        </p>
                        <h3
                          className="mb-0"
                          style={{
                            color: card.accent,
                            fontWeight: 700,
                          }}
                        >
                          <CountUp end={card.value} duration={3} />
                        </h3>
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>

          <div className="row mt-3">
            <div className="col-md-12 m-auto">
              <div className="card">
                <div className="card-header">Map</div>
                <KMLmap />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GvpDashboardReport;
